<template>
  <section>
    <div :class="$style.root">
      <template v-for="(img, _index) in imgList" :key="_index">
        <template v-if="img.url">
          <AtomsConsumerLink
            v-if="img.pc_img_url"
            :url="img.url"
            :style="`flex-basis: calc((100% - 1rem * ${pcImgColumn - 1}) / ${pcImgColumn});`"
            :class="$style.link"
            :width="640"
            :height="220"
            class="page-parts-pc"
          >
            <AtomsConsumerImage
              :src="img.pc_img_url ?? ''"
              :alt="img.pc_img_url_caption ?? ''"
              :class="$style.img"
              @click="trackBannerClick('banner', img.pc_img_url, _index, img.pc_img_url_caption ?? '')"
            />
          </AtomsConsumerLink>
          <AtomsConsumerLink
            v-if="img.sp_img_url"
            :url="img.url"
            :style="`flex-basis: calc((100% - 1rem * ${spImgColumn - 1}) / ${spImgColumn});`"
            :class="$style.link"
            :width="400"
            :height="270"
            class="page-parts-sp"
          >
            <AtomsConsumerImage
              :src="img.sp_img_url"
              :alt="img.sp_img_url_caption ?? ''"
              :class="$style.img"
              @click="trackBannerClick('banner', img.sp_img_url, _index, img.sp_img_url_caption ?? '')"
            />
          </AtomsConsumerLink>
        </template>
        <template v-else>
          <div class="page-parts-pc" :style="`flex-basis: calc((100% - 1rem * ${pcImgColumn - 1}) / ${pcImgColumn});`">
            <AtomsConsumerImage
              v-if="img.pc_img_url"
              :src="img.pc_img_url ?? ''"
              :alt="img.pc_img_url_caption ?? ''"
              :width="640"
              :height="220"
              :class="$style.img"
            />
          </div>
          <div class="page-parts-sp" :style="`flex-basis: calc((100% - 1rem * ${spImgColumn - 1}) / ${spImgColumn});`">
            <AtomsConsumerImage
              v-if="img.sp_img_url"
              :src="img.sp_img_url"
              :alt="img.sp_img_url_caption ?? ''"
              :width="400"
              :height="270"
              :class="$style.img"
            />
          </div>
        </template>
      </template>
    </div>
  </section>
</template>

<script setup lang="ts">
import { PagePartsFragmentFragment } from "~/types/pageParts"

type Props = {
  imgList: PagePartsFragmentFragment["list"]
  pcImgColumn?: number
  spImgColumn?: number
}

withDefaults(defineProps<Props>(), {
  pcImgColumn: 2,
  spImgColumn: 1,
})

const { trackBannerClick } = useGtagEvent()
</script>

<style module lang="scss">
.root {
  @include container-lg;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 1rem;
  .img {
    width: 100%;
  }
}
</style>
